// Component: TwoUp
// Author: Jay
import * as React from 'react';
import Section from '@rotaryintl/component-section';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { ColumnLayout, Layout, Column } from '@rotaryintl/component-column-layout';

const TwoUp = ({ rendering }) => {
  return (
    <>
      <Section backgroundStyle="gray-textured" sectionPadding="xl">
        <ColumnLayout columns={2} layout={Layout.Equal}>
          <Column>
            <Placeholder name="TwoUp-Left" rendering={rendering} />
          </Column>
          <Column>
            <Placeholder name="TwoUp-Right" rendering={rendering} />
          </Column>
        </ColumnLayout>
      </Section>
    </>
  );
};

export default withSitecoreContext()(TwoUp);
